import { createSafeContext } from '@/package';

import type { ModelTrainingFormContextValue } from './type';

const ModelTrainingFormContext =
  createSafeContext<ModelTrainingFormContextValue>();

export default ModelTrainingFormContext;
